<template>
    <div class="pipe-diameter-analysis">
        <div class="diameter-analysis-index-title">
            <span style="color: #fff;">管径分析</span>
            <div class="diameter-analysis-title">
                <div :class="{ active: selectedType === 'rain' }" @click="getDiameterLengthSum('rain')">雨</div>
                <div :class="{ active: selectedType === 'sewage' }" @click="getDiameterLengthSum('sewage')">污</div>
            </div>
        </div>
        <div v-for="item in diameterList" :key="item.id" class="diameter-analysis-item" >
            <div>DN{{ item.diameter }}</div>
            <div style="color: #299bc5">{{ item.total_length }}</div>
        </div>
    </div>
</template>

<script>
import { getDiameterLengthSum } from "@/views/pipe-info/api/pipe-info";
export default {
    name: "pipe-diameter-analysis",
    data() {
        return {
            diameterList: [],
            selectedType: 'rain',
            scrollTimer: null
        };
    },
    mounted() {
        this.getDiameterLengthSum('rain'); // 默认加载雨水管网数据
    },
    methods: {
        startScroll() {
            this.clearScrollTimer();
            if (this.diameterList.length <= 1) return;
            this.scrollTimer = setInterval(() => {
                const firstItem = this.diameterList.shift();
                this.diameterList.push(firstItem);
            }, 1000);
        },
        clearScrollTimer() {
            if (this.scrollTimer) {
                clearInterval(this.scrollTimer);
                this.scrollTimer = null;
            }
        },
        getDiameterLengthSum(type) {
            this.selectedType = type; // 更新选中类型
            const data = {
                type: type
            };
            getDiameterLengthSum(data).then(res => {
                console.log("res:", res);
                this.diameterList = res || [];
                this.startScroll();
            });
        }
    }
};
</script>

<style scoped>
.pipe-diameter-analysis {
    width: 48%;
    height: 23vh;
    overflow: hidden;
}
.diameter-analysis-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #adadad;
}
.diameter-analysis-index-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
}
.diameter-analysis-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: #adadad;
    margin: 0.2rem 0;
}
.diameter-analysis-title div {
    cursor: pointer;
    border: 1px solid #adadad;
    padding: 0 0.4rem;
}
.diameter-analysis-title div.active {
    color: #fff;
    border: 1px solid #299bc5;
    background: #299bc5;
}
</style>